// extracted by mini-css-extract-plugin
export default {"accordionContent":"Accordion_accordionContent__7ajcV","accordion-down":"Accordion_accordion-down__MxH8i","accordion-up":"Accordion_accordion-up__EgAfn"};